import React from 'react'
import logo from 'src/assets/images/logo.png'

const LogoHeader = () => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-center align-items-center">
          <img
            className="img-fluid"
            style={{ height: '70px', width: 'auto', marginRight: '10px' }}
            src={logo}
            alt="Logo"
          />
          <div className="d-flex flex-column align-items-center">
            <span className="mt-2" style={{ fontWeight: 'bold' }}>
              श्री कृष्ण आयुष विश्वविद्यालय, कुरूक्षेत्र
            </span>
            <span style={{ fontWeight: 'bold' }}>
             Shri Krishna Ayush University, Kurukshetra
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LogoHeader
